import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateInput", "startsAt", "submitButton", "inRoomCheckbox"]
  static values = { slotsPath: String }

  loadSlots() {
    const date = this.dateInputTarget.value
    if (!date) return

    this.#refreshSlotFrame(date)

    // Reset selection
    this.startsAtTarget.value = ""
    this.submitButtonTarget.disabled = true
    this.clearSlotSelection()
  }

  toggleInRoom() {
    const date = this.dateInputTarget.value
    if (!date) return

    this.#refreshSlotFrame(date)

    // Reset selection since available slots may change
    this.startsAtTarget.value = ""
    this.submitButtonTarget.disabled = true
    this.clearSlotSelection()
  }

  selectSlot(event) {
    const startsAt = event.currentTarget.dataset.startsAt
    this.startsAtTarget.value = startsAt
    this.submitButtonTarget.disabled = false

    // Highlight selected
    this.clearSlotSelection()
    event.currentTarget.classList.add("bg-amber-100", "border-amber-500", "text-amber-800")
    event.currentTarget.classList.remove("border-stone-300", "text-stone-700")
  }

  clearSlotSelection() {
    document.querySelectorAll(".slot-button").forEach(btn => {
      btn.classList.remove("bg-amber-100", "border-amber-500", "text-amber-800")
      btn.classList.add("border-stone-300", "text-stone-700")
    })
  }

  #refreshSlotFrame(date) {
    const frame = document.getElementById("available-slots")
    if (frame) {
      let basePath
      if (this.hasSlotsPathValue && this.slotsPathValue) {
        basePath = this.slotsPathValue
      } else {
        const pathParts = window.location.pathname.split("/")
        const locationSlug = pathParts[1]
        const treatmentId = pathParts[3]
        basePath = `/${locationSlug}/book/${treatmentId}/slots`
      }
      let url = `${basePath}?date=${date}`
      if (this.hasInRoomCheckboxTarget && this.inRoomCheckboxTarget.checked) {
        url += "&in_room=1"
      }
      frame.src = url
    }
  }
}
